export const PAYMENT_TYPE_ROBOTPAYMENT = "8f7bf6ad-3f92-4219-8479-c897be724532";
export const PAYMENT_TYPE_STRIPE = "9bbf6286-492e-42b1-a5b2-57e7e11fe026";
